<template>
  <div :key="id" class="row">
    <Select2
        container-class="form-group col-12 mb-7"
        :multiple="false"
        :show-search="true"
        :selectClass="'form-select form-control-sm form-select-solid'"
        :name="`${id}-country`"
        :label="$t('expense.label.country')"
        labelClass="form-label fs-6 text-black"
        :placeholder-text="$t('expense.placeholder.country')"
        v-model="countryFees.country">
      <option v-for="country in []" :value="country.id" :key="country.id">
        {{ country.title }}
      </option>
    </Select2>
    <div class="col-10 mx-auto">
      <ExpenseFeeForm
          v-for="(fee, key) in countryFees.fees"
          :key="key"
          :index="key"
          :id="id+'-'+key"
          :fee="fee"
          :symbol="'€'"
          @delete-row="deleteFeeRow"/>
      <div class="justify-content-end align-items-end float-end">
        <a class="btn btn-primary" @click.prevent="addFeeRow">
          {{ $t('expense.new.addFeeRow') }}
        </a>
        <a class="btn btn-primary" @click.prevent="() => deleteCountryRow(index)">
          {{ $t('expense.new.removeCountryRow') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import {computed, defineEmits, defineProps, ref, watch} from "vue";
import Input from "@/components/Input.vue";
import {useDiscountType} from "@/composables/discountType";
import {useStore} from "vuex";
import CreateTax from "@/components/Tax/CreateTax.vue";
import {$formatLocalAmount} from "@/mixins/Helpers";
import ExpenseFeeForm from "@/Modules/Financial/components/Expense/ExpenseFeeForm.vue";

const store = useStore()
const emits = defineEmits(["deleteCountryRow"])
const props = defineProps({
  countryFees: {
    type: Object,
    default: () => ({
      country: '',
      fees: [
        {
          expense_date: '',
          amount: 0,
          reason: '',
          files: []
        }
      ]
    })
  },
  symbol: String,
  index: Number,
  id: String,
})
const {discountType} = useDiscountType()

const countryFees = ref(props.countryFees)

const addFeeRow = () => {
  countryFees.value?.fees.push({
    expense_date: '',
    amount: 0,
    reason: '',
    files: []
  })
}

function deleteFeeRow(feeIndex) {
  if (countryFees.value.fees.length > 1) {
    countryFees.value.fees.splice(feeIndex, 1)
  }
}

function deleteCountryRow(index) {
  emits('deleteCountryRow', index)
}
</script>

<style scoped>
</style>
